import React from 'react';
import { motion } from 'framer-motion';
import { CtaButton } from './CtaButton';
import { heroGuarantees } from '../data/content';
export function Hero() {
  return <section className="w-full bg-cream px-5 pb-12 pt-[15px] sm:pb-20 sm:pt-10" data-id="element-115" data-mp="ei1unjxvvyww">
      <div className="mx-auto max-w-4xl text-center" data-id="element-116" data-mp="9l375k8q6q7o">
        <motion.p initial={{
        opacity: 0,
        y: 8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        ease: 'easeOut'
      }} className="text-[11px] font-bold uppercase leading-tight tracking-[0.18em] text-teal sm:text-xs sm:tracking-[0.22em]" data-id="element-117" data-mp="4mi47d239sfj">
          Le système n°1 pour les entraîneurs de basketball francophones
        </motion.p>

        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.05,
        ease: 'easeOut'
      }} className="mt-3 font-display text-[1.75rem] font-black leading-[1.1] tracking-tight text-navy sm:mt-5 sm:text-[2.75rem] md:text-[3.25rem]" data-id="element-118" data-mp="ncq2nhuufupe">
          Préparez une Année Entière de Basketball en Seulement{' '}
          <span className="italic text-grape" data-id="element-119" data-mp="3o85af8w3tx3i">5 Minutes</span> Chrono.
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.12,
        ease: 'easeOut'
      }} className="mx-auto mt-3 max-w-2xl text-[15px] leading-snug text-navy/60 sm:mt-6 sm:text-lg sm:leading-relaxed" data-id="element-120" data-mp="39al869qleg11">
          <span className="sm:hidden" data-id="element-121" data-mp="3599ik47pxusu">
            6 volumes PDF prêts à l&apos;emploi, de U7 à Seniors. Ouvrez, suivez
            le plan et entraînez.
          </span>
          <span className="hidden sm:inline" data-id="element-122" data-mp="2qi0mbc9b9b6q">
            Basketball Prêt™ est le système complet « clé en main » : 6 volumes
            PDF prêts à l&apos;emploi chargés de séances structurées, de
            progressions tactiques et de préparation physique, de U7 à Seniors.
            Il suffit d&apos;ouvrir, de suivre le plan et d&apos;entraîner.
          </span>
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.7,
        delay: 0.2,
        ease: 'easeOut'
      }} className="mx-auto mt-3 w-full max-w-[19rem] sm:mt-10 sm:max-w-md" data-id="element-123" data-mp="s44i1nkpdlhw">
          <img src="https://cdn.magicpatterns.com/patterns/generated-images/22060f28-b244-4c95-921f-381bf0ea7fa2.jpg" alt="Le pack Basketball Prêt : les 6 volumes de U7 à Seniors en éventail, le logo sur écran, la version numérique sur tablette et téléphone, les 5 bonus et du matériel de basketball" width={1080} height={1080} className="mx-auto aspect-square w-full object-contain" data-id="element-124" data-mp="degiaqs66uwa" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3,
        ease: 'easeOut'
      }} className="mt-3 sm:mt-8" data-id="element-125" data-mp="3lt74sotvtnt7">
          <CtaButton label="Obtenir le pack Basketball Prêt" href="#offre" data-id="element-126" data-mp="1xam4cnf59kxc" />
          <ul className="mt-4 flex flex-wrap items-center justify-center gap-x-2 gap-y-1 text-[11px] font-semibold text-navy/55 sm:mt-5 sm:gap-x-3 sm:gap-y-2 sm:text-xs" data-id="element-127" data-mp="21a4tjve00i5z">
            {heroGuarantees.map((item, index) => <li key={item} className="flex items-center gap-2 sm:gap-3" data-id="element-128" data-mp="2b2ahmu14qffw" data-mpi={index}>
                <span data-id="element-129" data-mp="2g0luzeqmv82v">
                  <span aria-hidden="true" className="text-teal" data-id="element-130" data-mp="2fzao361w5k7j">
                    ✓{' '}
                  </span>
                  {item}
                </span>
                {index < heroGuarantees.length - 1 && <span aria-hidden="true" className="text-navy/25" data-id="element-131" data-mp="2oye6e7t8hvkz">
                    ·
                  </span>}
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}